import React from 'react';
import { Route, Routes, useParams } from "react-router-dom";
import {Container} from 'react-bootstrap';
import UserProfile from './UserProfile';
import NotFound from '../../components/NotFound';
//import AccountSettings from './AccountSettings';
import LeftNav from '../../components/LeftNav';

const Settings = () => {
  //let {accountKey} = useParams();
  //let match = useRouteMatch();
  //can add exact={true} to / as well
  //console.log('in chatbots, accountKey', accountKey);

  let {accountKey} = useParams();

  return (
    <Container fluid>
      <LeftNav accountKey={accountKey}/>
      <Routes>
        {/*<Route path={`${match.path}/account`} component={AccountSettings} />*/}
        <Route path="/user" element={<UserProfile/>} />
        <Route path="/" element={<UserProfile/>}/>
        <Route element={<NotFound/>}  />
      </Routes>

    </Container>
  )
}

export default Settings;
